export enum Peripherals {
    GPIO = 'GPIO',
    TIMER32 = 'TIMER32',
    TIMER16 = 'TIMER16'
}